var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66659 12.6667C8.66659 12.8933 8.69325 13.1133 8.72659 13.3333H2.66659C2.31296 13.3333 1.97382 13.1929 1.72378 12.9428C1.47373 12.6928 1.33325 12.3536 1.33325 12V4C1.33325 3.26 1.92659 2.66666 2.66659 2.66666H6.66659L7.99992 4H13.3333C13.6869 4 14.026 4.14047 14.2761 4.39052C14.5261 4.64057 14.6666 4.97971 14.6666 5.33333V9.20666C14.2599 8.97333 13.8133 8.81333 13.3333 8.72666V5.33333H2.66659V12H8.72659C8.69325 12.22 8.66659 12.44 8.66659 12.6667ZM13.3333 12V10H11.9999V12H9.99992V13.3333H11.9999V15.3333H13.3333V13.3333H15.3333V12H13.3333Z",
    fill: "#8C8A94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder_icon.d67bf63cd924f8a6c9bdb1ae3884cb26.svg";
export { ForwardRef as ReactComponent };